// extracted by mini-css-extract-plugin
export var boldText = "_8k-4";
export var checkboxContainer = "_8k-6";
export var closeIcon = "_8k-i";
export var container = "_8k-0";
export var drawer = "_8k-8";
export var drawerContent = "_8k-9";
export var extraSmallText = "_8k-5";
export var fulfillmentGroupTable = "_8k-e";
export var largeText = "_8k-3";
export var loadingSpinnerContainer = "_8k-j";
export var mediumText = "_8k-2";
export var narrow = "_8k-f";
export var notificationLink = "_8k-l";
export var packageCheckIconContainer = "_8k-7";
export var slideoutHeaderActions = "_8k-g";
export var slideoutHeaderActionsShifted = "_8k-h";
export var slideoutHeaderContainer = "_8k-a";
export var slideoutModal = "_8k-c";
export var stickyHeaderWrapper = "_8k-b";
export var table = "_8k-k";
export var tableContainer = "_8k-d";
export var tertiaryText = "_8k-1";